<template>
  <div class="max-w-3xl space-y-4">
    <!-- Page header -->
    <div class="flex items-center gap-3">
      <span class="flex items-center justify-center w-10 h-10 rounded-xl bg-taxiye-100 text-taxiye-500">
        <span class="material-icons-round">lock_reset</span>
      </span>
      <div>
        <h2 class="text-lg font-semibold text-gray-800">Reset Password</h2>
        <p class="text-sm text-gray-500">Set a new password for this admin user.</p>
      </div>
    </div>

    <form @submit.prevent="resetPassword">
      <div class="p-6 space-y-6 bg-white border border-gray-200 rounded-2xl shadow-sm">
        <!-- Passwords row -->
        <div class="grid grid-cols-1 gap-5 sm:grid-cols-2">
          <label class="block">
            <span class="block text-xs font-semibold tracking-wider text-gray-600 uppercase">New Password</span>
            <input
              v-model="newPassword"
              :type="showPasswords ? 'text' : 'password'"
              class="w-full h-10 px-3 mt-1.5 text-sm text-gray-800 border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300"
              placeholder="New password"
            />
          </label>
          <label class="block">
            <span class="block text-xs font-semibold tracking-wider text-gray-600 uppercase">Confirm Password</span>
            <input
              v-model="confirmPassword"
              :type="showPasswords ? 'text' : 'password'"
              class="w-full h-10 px-3 mt-1.5 text-sm text-gray-800 border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300"
              placeholder="Confirm password"
            />
          </label>
        </div>

        <!-- Show passwords + validation message -->
        <div class="flex items-center justify-between">
          <label class="inline-flex items-center text-sm text-gray-600 cursor-pointer">
            <input
              type="checkbox"
              v-model="showPasswords"
              class="mr-2 border-gray-300 rounded form-checkbox text-taxiye-500 focus:border-taxiye-300"
            />
            <span>Show passwords</span>
          </label>
          <p class="flex items-center text-xs text-red-500" v-if="invalid && errorMessage">
            <i class="mr-1 text-sm material-icons-round">error_outline</i>
            {{ errorMessage }}
          </p>
        </div>
      </div>

      <!-- Actions -->
      <div class="flex items-center justify-between mt-4">
        <router-link
          to="/accounts"
          class="inline-flex items-center h-10 px-4 text-sm font-semibold text-gray-600 border border-gray-300 rounded-xl transition-colors duration-150 hover:bg-gray-50 hover:text-gray-800"
        >
          <i class="mr-1 text-base material-icons-round">arrow_back</i>
          <span>Back</span>
        </router-link>
        <button
          :disabled="busy || invalid"
          class="inline-flex items-center h-10 px-5 text-sm font-semibold text-white shadow-sm rounded-xl transition-colors duration-150"
          :class="{
            'bg-taxiye-200 cursor-not-allowed': invalid || busy,
            'bg-taxiye-500 hover:bg-taxiye-600': !invalid && !busy,
          }"
        >
          <i v-if="busy" class="mr-1 text-base material-icons-round spin">sync</i>
          <i v-else class="mr-1 text-base material-icons-round">vpn_key</i>
          <span>Set New Password</span>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      busy: false,
      newPassword: "",
      confirmPassword: "",
      startValidating: false,
      showPasswords: false,
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    invalid() {
      return (
        this.newPassword.length < 8 || this.newPassword !== this.confirmPassword
      );
    },
    errorMessage() {
      if (this.startValidating) {
        if (this.newPassword.length < 8)
          return "password too short (< 8 chars.)";
        else if (this.newPassword !== this.confirmPassword)
          return "passwords don't match";
        return "";
      }
      return "";
    },
    validationTrigger() {
      return this.newPassword + this.confirmPassword;
    },
  },
  created() {},
  methods: {
    resetPassword() {
      this.busy = true;
      this.$misc
        .post(`accounts/${this.id}/reset-password`, {
          newPassword: this.newPassword
        })
        .then(() => {
          window.flash({
            body: "Password set successfully!",
            type: "success",
          });
          this.$router.push("/accounts");
        })
        .catch((err) => {
          window.flash({ body: "Failed to set new password!", type: "error" });
          console.log(err);
        })
        .finally(() => (this.busy = false));
    },
  },
  watch: {
    validationTrigger() {
      if (!this.startValidating) this.startValidating = true;
    },
  },
};
</script>
